import React, { useState } from "react";
import { observer } from "mobx-react";
import PromoCodesStore from "src/stores/PromoCodesStore";
import { Spinner, Button, PieTimer } from "../..";
import "./ConfirmDeleteProductModal.scss";

function ConfirmDeleteProductModal({ promoCode, close }) {
  const { id: promoCodeId, code } = promoCode || {};

  const [deleteEnabled, setDeleteEnabled] = useState(false);
  const enableDelete = () => setDeleteEnabled(true);

  const [deleting, setDeleting] = useState(false);

  const deletePromoCode = async () => {
    setDeleting(true);
    await PromoCodesStore.deletePromoCode(promoCodeId);
    close();
  };

  const cancelButtonStyles = deleting ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = deleting ? { opacity: 0.3, pointerEvents: "none" } : {};
  const actionButtonContent = deleting ? <Spinner /> : "Remove Promo Code";
  const actionButton = deleteEnabled ? (
    <Button type="negative" action={deletePromoCode} style={actionButtonStyles}>
      {actionButtonContent}
    </Button>
  ) : (
    <div className="timer-container">
      <PieTimer color="var(--red)" width={24} height={24} duration={3000} onComplete={enableDelete} />
    </div>
  );

  return (
    <div className="confirm-delete-promo-code-modal">
      <div className="content">
        <div className="title">Are you sure you want to remove {code}?</div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">{actionButton}</div>
      </div>
    </div>
  );
}

export default observer(ConfirmDeleteProductModal);
